const shortToLongWeekday = (shortWeekday: string): string => {
  switch (shortWeekday.toLowerCase()) {
    case "mon":
      return "Monday";
    case "tue":
      return "Tuesday";
    case "wed":
      return "Wednesday";
    case "thu":
      return "Thursday";
    case "fri":
      return "Friday";
    case "sat":
      return "Saturday";
    case "sun":
      return "Sunday";
    default:
      return shortWeekday;
  }
};

export default shortToLongWeekday;
